import { Dialog, DialogContent } from "@/components/podkit/modal/Modal";
import { type SSOConfiguration } from "gitpod-next-api/gitpod/v1/organization_pb";
import { useCallback, useState, type FC } from "react";
import { ConfigureSSO } from "./ConfigureSSO";
import { DomainVerification } from "./DomainVerification";

export type SetupSSOModalStep = "configure-sso" | "domain-verification";

export type SetupSSOModalProps = {
    onClose?: () => void;
    testValidationOnly?: boolean;
    organizationId: string;
    config?: SSOConfiguration;
    step?: SetupSSOModalStep;
};

const noop = () => void 0;

export const SetupSSOModal: FC<SetupSSOModalProps> = ({
    onClose = noop,
    testValidationOnly,
    organizationId,
    config,
    step,
}) => {
    const [currentStep, setCurrentStep] = useState<SetupSSOModalStep>(step ?? "configure-sso");

    const handleOpenChange = useCallback(
        (nextOpen: boolean) => {
            if (!nextOpen) {
                onClose?.();
            }
        },
        [onClose],
    );

    return (
        <Dialog open onOpenChange={handleOpenChange}>
            <DialogContent className="flex max-w-[600px] flex-col p-6" data-track-location="setup_sso_modal">
                {currentStep === "domain-verification" && config?.emailDomain && (
                    <DomainVerification
                        domain={config.emailDomain}
                        onCancel={onClose}
                        organizationId={organizationId}
                    />
                )}
                {currentStep === "configure-sso" && (
                    <ConfigureSSO
                        organizationId={organizationId}
                        config={config}
                        onClose={onClose}
                        onVerify={() => setCurrentStep("domain-verification")}
                        testValidationOnly={testValidationOnly}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
};
